import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { FundAccountModalComponent } from '@pg-app/client/client-dashboard/components/fund-account/modal/modal.component';
import { FundAccountModel } from '@pg-app/client/client-dashboard/components/fund-account/service/fund-account.model';
import { FundAccountService } from '@pg-app/client/client-dashboard/components/fund-account/service/fund-account.service';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SendPaymentInstructionService } from '../send-payment-instruction/services/send-payment-instruction.service';
import { environment } from '@pg-env/environment';
import { ShareService } from '@nttp/common-service/share-service';

@Component({
  selector: 'np-client-dashboard',
  templateUrl: './client-dashboard.component.html',
  styleUrls: ['./client-dashboard.component.scss']
})
export class ClientDashboardComponent implements OnInit {
  errors = [];
  notVerify = false;

  fundAccountModel: FundAccountModel;

  allBalances: any;
  availableCurrencies: any;
  tradeCentre = true;


  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private fundAccountService: FundAccountService,
    private location: Location,
    private sendPaymentservice: SendPaymentInstructionService,
    private toastrService: ToastrService,
    private shareService: ShareService
  ) {}

  ngOnInit() {
    const params = {
      userId: null
    };
    this.sendPaymentservice.getAllBalancesAndAvailableCurrencies(params).subscribe(data => {
      this.allBalances = data.allBalances;
      this.availableCurrencies = data.availableCurrencies;
    });
    this.shareService.accountType$.subscribe(res => {
      this.tradeCentre = res.tradeCentre;
    })

    if (!window.location.href.toLowerCase().endsWith('/client/dashboard')) {
      const queryParams = this.route.snapshot.queryParams;
      
      let requestId = queryParams['request_id'];
      if (!requestId) {
        requestId = queryParams['requestId'];
      }
      if (!requestId) {
        requestId = queryParams['request-id'];
      }

      if (!window.location.href.toLowerCase().endsWith('/client/dashboard')) {
        // This will remove all the parameters returned from Reflow on the url WITHOUT reloading the dashboard in the background
        this.location.replaceState('/client/dashboard');
      }
      
      if (!requestId) {
        // Fatal error - request id is not returned in the query string
        // i.e. something has gone wrong and we have no way to locate the original payment
        const logMessage = {
          logLevel: 4,      // 2: info, 3: warning, 4: error
          message: 'Fatal error. Request id not returned in query string.',
          data: queryParams
        };
        this.fundAccountService.postLogMessage(logMessage).subscribe(
          () => {
            this.toastrService.error(`Instant payment failed. Please contact via email help@${environment.domain} or phone ${environment.phone}.`);
          })
      } else {
        this.fundAccountService.postProcessCallback(queryParams).subscribe(
          res => {
            // IOT payment callback succeeded... and show user the final dialog
            this.showFinalDialogAfterIot(requestId, true);
          },
          err => {
            // IOT payment callback failed... and show user the final dialog
            this.showFinalDialogAfterIot(requestId, false);
          }
        );        
      }
    }
  }

  private showFinalDialogAfterIot(ourPaymentRef: any, isOk: any) {
    this.fundAccountService.getTradeAfterIOT(ourPaymentRef).subscribe(
      // Load the trade from service
      data => {
        this.fundAccountModel = {
          buyAmount: data.currencyBuy.amount,
          payAmount: data.currencySell.amount,
          exchangeRate: data.exchangeRate,
          exchangeFee: data.exchangeFee,
          valueDate: data.valueDate,
          currencyCodeBuy: { code: data.currencyBuy.code, id: data.currencyBuy.id },
          currencyCodePay: { code: data.currencySell.code, id: data.currencySell.id },
          tradeReference: data.tradeReference,
          tradeId: data.tradeId,
          deposited: undefined,
          showDeposited: false,
          isSellChanged: false,
          isForwardTrade: false,
          holidays: [],
          depositCurrencyId: undefined,

          iotInfo: { redirectedFromIOT: true, processedOkIOT: isOk }
        };

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.hasBackdrop = true;
        dialogConfig.panelClass = 'custom-dialog';
        dialogConfig.data = this.fundAccountModel;

        this.dialog
          .open(FundAccountModalComponent, dialogConfig)
          .afterClosed()
          .subscribe(() => {
            // Nothing to do
          });
      }
    );
  }
}
